// Account API
import ajax from './_ajax';

const api = {};
api.getBannerByKey = function (key) {
  return ajax.get('/api/Banner/GetByKey?key=' + key);
};
api.getHotKeywords = function (take) {
  return ajax.get('/api/Common/GetHotKeywords?take=' + take);
};

api.getActivityAreaByKey = function (activityAreaKey) {
  return ajax.get('/api/ActivityArea/GetActivityAreaByKey?activityAreaKey=' + activityAreaKey);
};
api.uploadFile = function (params) {
  return ajax.post('/api/File/UploadFile', params);
};
api.sendVerifyCode = function (params) {
  return ajax.post('/api/Sms/SendVerifyCode', params);
};
api.checkVerifyCode = function (params) {
  return ajax.post('/api/Sms/CheckVerifyCode', params);
};
api.getAllCountryInfo = function (params) {
  return ajax.get('/api/Country/GetAllCountryInfo');
};
// News
api.getRecentNews = function () {
  const params = {
    NewsType: 0,
    Take: 6
  };
  return ajax.post('/api/News/GetRecentList', params);
};
api.getLatestAnnounce = function () {
  const params = {
    NewsType: 1,
    Take: 1
  };
  return ajax.post('/api/News/GetRecentList', params);
};

// country
api.getStatesByCountryId = function (id) {
  return ajax.get('/api/Country/GetStatesByCountryId?countryId=' + id);
};
api.getCitiesByStateId = function (id) {
  return ajax.get('/api/Country/GetCitiesByStateId?stateId=' + id);
};
api.getManufacturerById = function (id) {
  return ajax.get('/api/Manufacturer/GetById?id=' + id);
};
api.getNearestWarehouseByCityId = function (id) {
  return ajax.get('/api/Warehouse/GetNearestWarehouseByCityId?cityId=' + id);
};
api.autoLoginForValetOrder = function (hash) {
  return ajax.get('/api/Account/AutoLoginForValetOrder?hash=' + hash);
};
api.getOnlineQQ = function () {
  return ajax.get('/api/Home/GetOnlineQQ');
};
api.getOnlinePhone = function () {
  return ajax.get('/api/Home/GetOnlinePhone');
};
api.activityAreaGetCatalogProducts = function (data) {
  return ajax.post('/api/ActivityArea/GetCatalogProducts', data);
};
api.getWxCodeUnlimit = function () {
  return ajax.get('/api/account/GetWxCodeUnlimit');
};
export default api;



// WEBPACK FOOTER //
// ./src/api/commonApi.js